import { create } from "zustand";
import { persist } from "zustand/middleware";

interface MultiCameraStore {
  extraCameras: Record<number, string[]>;
  addCamera: (machineId: number, deviceMxid: string) => void;
  removeCamera: (machineId: number, deviceMxid: string) => void;
  getCameras: (machineId: number) => string[];
}

export const useMultiCameraStore = create<MultiCameraStore>()(
  persist(
    (set, get) => ({
      extraCameras: {},

      addCamera: (machineId, deviceMxid) =>
        set((state) => {
          const current = state.extraCameras[machineId] || [];
          if (current.includes(deviceMxid)) return state;
          return {
            extraCameras: {
              ...state.extraCameras,
              [machineId]: [...current, deviceMxid],
            },
          };
        }),

      removeCamera: (machineId, deviceMxid) =>
        set((state) => {
          const current = state.extraCameras[machineId] || [];
          const updated = current.filter((id) => id !== deviceMxid);
          return {
            extraCameras: {
              ...state.extraCameras,
              [machineId]: updated,
            },
          };
        }),

      getCameras: (machineId) => get().extraCameras[machineId] || [],
    }),
    {
      name: "maestro-multi-camera",
    }
  )
);
